// extracted by mini-css-extract-plugin
export default {"pie":"GeneralExp_pie__3CRwd"};